import { gql } from "apollo-boost";

export const CREATE_AMAZON_IDEA = gql`
    mutation createAmazonIdea($input: CreateAmazonIdeaInput!) {
        createAmazonIdea(input: $input) {
            id
        }
    }
`;

export const UPDATE_AMAZON_IDEA = gql`
    mutation updateAmazonIdea($input: UpdateAmazonIdeaInput!) {
        updateAmazonIdea(input: $input) {
            id
        }
    }
`;

export const DELETE_AMAZON_IDEA = gql`
    mutation deleteAmazonIdea($ids: [ID!]!) {
        deleteAmazonIdea(ids: $ids)
    }
`;

export const DUPLICATION_AMAZON_IDEA = gql`
    mutation duplicationAmazonIdea($input: DuplicationAmazonIdeaInput!) {
        duplicationAmazonIdea(input: $input) {
            id
        }
    }
`;

export const DIVISION_AMAZON_IDEA = gql`
    mutation divisionAmazonIdea($totalKpi: Int!, $supporterIDs: [ID!]!) {
        divisionAmazonIdea(totalKpi: $totalKpi, supporterIDs: $supporterIDs)
    }
`;

export const ASSIGN_AMAZON_IDEA = gql`
    mutation assignAmazonIdea(
        $ids: [ID!]!
        $supporterID: ID
        $storeIDs: [ID!]
    ) {
        assignAmazonIdea(
            ids: $ids
            supporterID: $supporterID
            storeIDs: $storeIDs
        )
    }
`;

export const PICK_AMAZON_IDEA = gql`
    mutation pickAmazonIdea($ids: [ID!]!) {
        pickAmazonIdea(ids: $ids)
    }
`;

// export const MARK_AMAZON_IDEA_DONE = gql`
//     mutation markAmazonIdeaDone($ids: [ID!]!) {
//         markAmazonIdeaDone(ids: $ids)
//     }
// `;

export const MARK_AMAZON_IDEA_DONE = gql`
    mutation markAmazonIdeaDone(
        $ids: [ID!]!
        $asin: String
        $productLink: String
        $storeIDs: [ID!]
    ) {
        markAmazonIdeaDone(
            ids: $ids
            asin: $asin
            productLink: $productLink
            storeIDs: $storeIDs
        )
    }
`;

export const MARK_AMAZON_IDEA_DONE_V2 = gql`
    mutation markAmazonIdeaDoneV2($input: [UpdateAmazonIdeaProductInput!]!) {
        markAmazonIdeaDoneV2(input: $input)
    }
`;

export const UPDATE_AMAZON_IDEA_PRODUCT = gql`
    mutation updateAmazonIdeaProduct($input: [UpdateAmazonIdeaProductInput!]!) {
        updateAmazonIdeaProduct(input: $input)
    }
`;

export const UPDATE_AMAZON_IDEA_PRODUCT_STATUS = gql`
    mutation updateAmazonIdeaProductStatus(
        $ids: [ID!]!
        $status: AmazonIdeaProductStatus!
    ) {
        updateAmazonIdeaProductStatus(ids: $ids, status: $status)
    }
`;

export const MARK_AMAZON_IDEA_BADGE = gql`
    mutation markAmazonIdeaBadge($ids: [ID!]!, $hexColor: String!) {
        markAmazonIdeaBadge(ids: $ids, hexColor: $hexColor)
    }
`;

export const ACCEPT_AMAZON_IDEA = gql`
    mutation acceptAmazonIdea($ids: [ID!]!) {
        acceptAmazonIdea(ids: $ids)
    }
`;

export const MARK_AMAZON_IDEA_NEED_REVIEW = gql`
    mutation markAmazonIdeaNeedReview(
        $id: ID!
        $asin: String
        $productLink: String
    ) {
        markAmazonIdeaNeedReview(
            id: $id
            asin: $asin
            productLink: $productLink
        )
    }
`;

export const DENY_AMAZON_IDEA = gql`
    mutation denyAmazonIdea($ids: [ID!]!, $reason: String!) {
        denyAmazonIdea(ids: $ids, reason: $reason)
    }
`;

export const START_AMAZON_IDEA = gql`
    mutation startAmazonIdea($ids: [ID!]!, $storeIDs: [ID!]) {
        startAmazonIdea(ids: $ids, storeIDs: $storeIDs)
    }
`;

export const MARK_AMAZON_IDEA_STATUS_DONE = gql`
    mutation markAmazonIdeaStatusDone($ids: [ID!]!) {
        markAmazonIdeaStatusDone(ids: $ids)
    }
`;

export const REJECT_AMAZON_IDEAS = gql`
    mutation rejectAmazonIdeas($ids: [ID!]!, $reason: String!) {
        rejectAmazonIdeas(ids: $ids, reason: $reason)
    }
`;

export const UPDATE_KPI_FOR_AMAZON_IDEA = gql`
    mutation updateKPIForAmazonIdea($ids: [ID!]!, $kpi: Float!) {
        updateKPIForAmazonIdea(ids: $ids, kpi: $kpi)
    }
`;

export const CREATE_AMAZON_IDEA_TEMPLATE = gql`
    mutation createAmazonIdeaTemplate($input: CreateAmazonIdeaTemplateInput!) {
        createAmazonIdeaTemplate(input: $input) {
            id
        }
    }
`;

export const UPDATE_AMAZON_IDEA_TEMPLATE = gql`
    mutation updateAmazonIdeaTemplate($input: UpdateAmazonIdeaTemplateInput!) {
        updateAmazonIdeaTemplate(input: $input) {
            id
        }
    }
`;

export const DELETE_AMAZON_IDEA_TEMPLATE = gql`
    mutation deleteAmazonIdeaTemplate($ids: [ID!]!) {
        deleteAmazonIdeaTemplate(ids: $ids)
    }
`;

export const DUPLICATION_AMAZON_IDEAS = gql`
    mutation duplicationAmazonIdeas($input: [DuplicationAmazonIdeaInput!]!) {
        duplicationAmazonIdeas(input: $input)
    }
`;

export const UPDATE_AMAZON_IDEAS_STORE = gql`
    mutation updateAmazonIdeasStore($input: [UpdateAmazonIdeaStoreInput!]!) {
        updateAmazonIdeasStore(input: $input)
    }
`;
